import React, {memo} from "react";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "../../../components/common/StyledToolTip";
import styles from "./styles";
import EquipmentDefectsIcon from "../../icons/EquipmentDefects";

const EquipmentDefects = ({ classes, handleClick }) => {
  return (
    <div
      className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons`}
    >
      <Tooltip title="E-DVIR info">
        <div className="trailer-defect-wrapper" onClick={handleClick}>
          <EquipmentDefectsIcon />
        </div>
      </Tooltip>
    </div>
  );
};

export default withStyles(styles)(memo(EquipmentDefects));
